import React, { useContext } from "react";

import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

import { P } from "../../atoms/Texts";
import { DarkFormField } from "../../atoms/Inputs";
import { PrimaryButton } from "../../atoms/Buttons";
import { demoContext } from "../../../shared/store/contexts";
import { toastWarning } from "../../../shared/helpers";

const ProfileUpdate = () => {
  const { organization } = useContext(demoContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstName: "John",
      lastName: "Doe",
      avatarUrl: "",
    },
  });

  const onProfileUpdate = (data) => {
    toastWarning("Cannot perform this action on Demo mode");
  };

  return (
    <form onSubmit={handleSubmit(onProfileUpdate)} className="mt-10">
      <div className="w-full mt-10 mx-auto">
        <div className="mx-auto">
          <div className="w-full mx-auto lg:mx-0 lg:w-1/2">
            <div>
              <DarkFormField
                type="text"
                id="firstName"
                name="firstName"
                color="#F8F6FE"
                className="py-1 px-2"
                label="First Name"
                placeholder="Enter your first name"
                defaultValue={"John"}
                iconBeforeClass=""
                inputClassName="-ml-3"
                {...register("firstName", {
                  required: "Please enter your first name",
                })}
              />
              <ErrorMessage
                errors={errors}
                name="firstName"
                as={
                  <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />
                }
              >
                {({ messages }) =>
                  messages &&
                  Object.entries(messages).map(([type, message]) => (
                    <P key={type}>{message}</P>
                  ))
                }
              </ErrorMessage>
            </div>

            <div>
              <DarkFormField
                type="text"
                id="lastName"
                name="lastName"
                color="#F8F6FE"
                className="py-1 px-2"
                label="Last Name"
                placeholder="Enter your last name"
                defaultValue={"Doe"}
                iconBeforeClass=""
                inputClassName="-ml-3"
                {...register("lastName", {
                  required: "Please enter your last name",
                })}
              />
              <ErrorMessage
                errors={errors}
                name="lastName"
                as={
                  <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />
                }
              >
                {({ messages }) =>
                  messages &&
                  Object.entries(messages).map(([type, message]) => (
                    <P key={type}>{message}</P>
                  ))
                }
              </ErrorMessage>
            </div>

            <div>
              <DarkFormField
                type="email"
                id="email"
                name="email"
                w="135px"
                disabled
                placeholder="example@mail.com"
                label="Work Email"
                defaultValue={organization.email}
                className="w-full"
              />
            </div>

            <div>
              <DarkFormField
                type="organization"
                id="organization"
                name="organization"
                w="135px"
                disabled
                placeholder="exampleOrganisation"
                label="Organization"
                defaultValue={organization?.name}
                className="w-full"
              />
            </div>

            <div>
              <DarkFormField
                type="position"
                id="position"
                name="position"
                w="135px"
                disabled
                placeholder="CEO"
                label="Position"
                defaultValue={"CEO"}
                className="w-full"
              />
            </div>
          </div>

          <div className="mb-10 mt-8 mx-auto flex gap-5">
            <div className="w-full">
              <PrimaryButton className="lg:w-1/2">Save changes</PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ProfileUpdate;
